import axios from "axios";
import moment from "moment";

const multilangfields = ["tags"];
const objectfieldsfields = ["achievements", "bio"];
const fields = ["postalcodes", "mails"];

const db = {
  get: function(type, id) {
    return new Promise((resolve, reject) => {
      axios({
        method: "get",
        headers: {
          accept: "application/json",
          "Content-Type": "application/json"
        },
        url: `/api/db/${type}/${id}`
      })
        .then(response => {
          resolve(this.turnArrayFieldsIntoString(response, type));
        })
        .catch(err => {
          if (err.response) {
            if (err.response.status === 401) {
              window.location.reload();
            }
          }
          reject(err);
        });
    });
  },
  getMultiple: function(type, ids) {
    return new Promise((resolve, reject) => {
      axios({
        method: "post",
        headers: {
          accept: "application/json",
          "Content-Type": "application/json"
        },
        url: `/api/db/${type}`,
        data: {
          ids: ids
        }
      })
        .then(response => {
          resolve(response);
        })
        .catch(err => {
          if (err.response) {
            if (err.response.status === 401) {
              window.location.reload();
            }
          }
          reject(err);
        });
    });
  },
  query: function(type, query) {
    return new Promise((resolve, reject) => {
      axios({
        method: "post",
        headers: {
          accept: "application/json",
          "Content-Type": "application/json"
        },
        url: `/api/db/${type}/query`,
        data: query
      })
        .then(response => {
          resolve(response);
        })
        .catch(err => {
          if (err.response) {
            if (err.response.status === 401) {
              window.location.reload();
            }
          }
          console.log(err);
          reject(err);
        });
    });
  },
  create: function(type, query) {
    return new Promise((resolve, reject) => {
      axios({
        method: "put",
        headers: {
          accept: "application/json",
          "Content-Type": "application/json"
        },
        url: `/api/db/${type}/create`,
        data: this.turnStringFieldsIntoArray(query, type)
      })
        .then(response => {
          resolve(this.turnArrayFieldsIntoString(response, type));
        })
        .catch(err => {
          if (err.response) {
            if (err.response.status === 401) {
              window.location.reload();
            }
          }
          reject(err);
        });
    });
  },
  patch: function(type, query) {
    return new Promise((resolve, reject) => {
      axios({
        method: "patch",
        headers: {
          accept: "application/json",
          "Content-Type": "application/json"
        },
        url: `/api/db/${type}/patch`,
        data: this.turnStringFieldsIntoArray(query, type)
      })
        .then(response => {
          resolve(this.turnArrayFieldsIntoString(response, type));
        })
        .catch(err => {
          if (err.response) {
            if (err.response.status === 401) {
              window.location.reload();
            }
          }
          reject(err);
        });
    });
  },
  delete: function(type, id) {
    return new Promise((resolve, reject) => {
      axios({
        method: "delete",
        headers: {
          accept: "application/json",
          "Content-Type": "application/json"
        },
        url: `/api/db/${type}/delete/${id}`
      })
        .then(response => {
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  turnArrayFieldsIntoString: function(response, type = "") {
    if (type !== "person" && type !== "group" && type !== "client") {
      return response;
    }

    const data = response.data;

    for (var i = fields.length - 1; i >= 0; i--) {
      var fieldname = fields[i];
      if (data[fieldname] && Array.isArray(data[fieldname])) {
        data[fieldname] = data[fieldname].join();
      }
    }

    for (var ind = multilangfields.length - 1; ind >= 0; ind--) {
      var mfieldname = multilangfields[ind];
      if (data[mfieldname]) {
        data[mfieldname] = {
          nb: data[mfieldname].nb ? data[mfieldname].nb.join() : "",
          en: data[mfieldname].en ? data[mfieldname].en.join() : "",
          de: data[mfieldname].de ? data[mfieldname].de.join() : ""
        };
      }
    }

    for (var i3 = objectfieldsfields.length - 1; i3 >= 0; i3--) {
      var ofieldname = objectfieldsfields[i3];
      if (!data[ofieldname]) {
        data[ofieldname] = {
          nb: "",
          en: "",
          de: ""
        };
      }
    }

    response.data = data;

    return response;
  },
  turnStringFieldsIntoArray: function(data, type = "") {
    if (type !== "person" && type !== "group" && type !== "client") {
      return data;
    }

    for (var i = fields.length - 1; i >= 0; i--) {
      var fieldname = fields[i];

      if (data[fieldname] && !Array.isArray(data[fieldname])) {
        data[fieldname] = data[fieldname].split(",").sort();
      }
    }

    for (var i2 = multilangfields.length - 1; i2 >= 0; i2--) {
      var mfieldname = multilangfields[i2];
      if (data[mfieldname]) {
        data[mfieldname] = {
          nb: data[mfieldname].nb ? data[mfieldname].nb.split(",").sort() : [],
          en: data[mfieldname].en ? data[mfieldname].en.split(",").sort() : [],
          de: data[mfieldname].de ? data[mfieldname].de.split(",").sort() : []
        };
      }
    }

    for (var i3 = objectfieldsfields.length - 1; i3 >= 0; i3--) {
      var ofieldname = objectfieldsfields[i3];
      if (data[ofieldname]) {
        if (
          typeof data[ofieldname] !== "object" ||
          Object.prototype.toString.call(data[ofieldname]) === "[object Array]"
        ) {
          data[ofieldname] = {
            no: data[ofieldname] ? data[ofieldname] : "",
            en: "",
            de: ""
          };
        }
      }
    }

    return data;
  },
  prepPersonQuery: function(params, sort = null) {
    const query = {};

    if (params.session_operation === "edit") {
      params.session_date = null;
    }

    let date;

    Object.keys(params).map(function(key) {
      if (key === "session_date" && params[key]) {
        query.day = moment(params.session_date).format("D");
        query.month = moment(params.session_date).format("M");
        query._session_date = moment(params.session_date).format("YYYY-MM-DD");
      } else if (key === "postalcode" && params[key].length === 4) {
        query.postalcode = params[key];
      } else if (key === "male" && params[key]) {
        query.gender = "male";
      } else if (key === "female" && params[key]) {
        query.gender = "female";
      } else if (key === "age" && params[key].length > 1) {
        if (params.session_date) {
          date = moment(params.session_date);
        } else {
          date = moment();
        }
        query.year = [parseInt(date.format("YYYY")) - parseInt(params[key])];
      } else if (key === "famous" && params[key]) {
        query.famous = true;
      } else if (key === "sport" && params[key]) {
        query.sport = true;
      } else if (key === "mention" && params[key]) {
        query.mentioned = true;
      } else if (key === "dead") {
        if (params[key]) {
          query.code = [1, 2, 3, 4, 5];
        } else {
          query.code = [1];
        }
      } else if (key === "glory" && params[key]) {
        query.glory = true;
      } else if (
        key === "session_operation" &&
        params[key] === "mention" &&
        params.age.length < 1
      ) {
        const ages = [
          50,
          60,
          70,
          75,
          80,
          85,
          90,
          95,
          100,
          101,
          102,
          103,
          104,
          105,
          106,
          107,
          108,
          109,
          110
        ];
        let years = [];
        for (var i = ages.length - 1; i >= 0; i--) {
          years.push(
            parseInt(moment(params.session_date).format("YYYY")) -
              parseInt(ages[i])
          );
        }
        query.year = years;
      } else if (key === "string") {
        query.text = params[key];
      }

      return "";
    });

    if (
      !params.famous &&
      !params.mention &&
      params.session_operation === "fleng"
    ) {
      query._should = {};
      query._should.famous = true;
      //query._should.fleng = true;
    }

    if (
      params.session_operation === "mention" ||
      (params.session_operation === "edit" && !query.glory)
    ) {
      query._must_not = {};
      query._must_not.fleng = true;
    }

    if (params.assets_from || params.assets_to) {
      if (params.assets_from && params.assets_to) {
        query.assets = {
          from: params.assets_from,
          to: params.assets_to
        };
      } else if (params.assets_from) {
        query.assets = {
          from: params.assets_from,
          to: 900000000
        };
      } else if (params.assets_to) {
        query.assets = {
          from: 0,
          to: params.assets_to
        };
      }
    }

    if (params.income_from || params.income_to) {
      if (params.income_from && params.income_to) {
        query.income = {
          from: params.income_from,
          to: params.income_to
        };
      } else if (params.income_from) {
        query.income = {
          from: params.income_from,
          to: 900000000
        };
      } else if (params.income_to) {
        query.income = {
          from: 0,
          to: params.income_to
        };
      }
    }

    if (sort) {
      query._sort = sort;
    }

    return query;
  }
};

export default db;
